import { Drawer } from "melco-ui";
import { Drawer as DrawerType } from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { FontCollectionReferencesList } from "./FontCollectionReferencesList";

type FontCollectionReferencesDrawerProps = {
  drawer: DrawerType;
  id: string;
};

export const FontCollectionReferencesDrawer: React.FC<
  FontCollectionReferencesDrawerProps
> = ({ drawer, id: fontCollectionId }) => {
  const { t } = useTranslation();
  const { closeDrawer, isDrawerOpen } = drawer;

  return (
    <Drawer
      title={t("font_collections.actions.references.title")}
      placement="right"
      width={1000}
      closable={true}
      onClose={closeDrawer}
      open={isDrawerOpen}
      bodyStyle={{ padding: 0 }}
    >
      <FontCollectionReferencesList fontCollectionId={fontCollectionId} />
    </Drawer>
  );
};
